var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3056 0H7.6945C3.59449 0 0.260376 3.39738 0.260376 7.57035V21.4282C0.260376 25.6026 3.59587 28.9986 7.6945 28.9986H11.9173V18.7741H8.22029V14.3988H11.9173V10.5659C11.9173 7.62796 14.2565 5.24642 17.1421 5.24642H20.7798V9.43765H18.2337C17.2387 9.43765 16.4314 10.2596 16.4314 11.2726V14.3637H20.4555L19.811 18.7067H16.4314V28.9986H21.3056C25.4056 28.9986 28.7397 25.6012 28.7397 21.4282V7.57035C28.7397 3.39598 25.4042 0 21.3056 0Z",
    fill: "#3D2C06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.51fc84d5c2c4d72f732fd9129c73efb7.svg";
export { ForwardRef as ReactComponent };